(() => {
  const sliders = document.querySelectorAll('[data-content-slider]');

  for (const slider of sliders) {
    let delay = parseFloat(slider.dataset.swiperAutoplay);
    let isAutoplay = !!delay;

    let swiperConfig = {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 28,
      grabCursor: true,
      keyboard: {
        enabled: true
      },
      autoplay: {
        delay: delay,
        enabled: isAutoplay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }
    }

    const paginationEl = slider.querySelector('.content_slider__pagination');
    const prevCtrlEl = slider.querySelector('.swiper-button-prev');
    const nextCtrlEl = slider.querySelector('.swiper-button-next');
    const slideType = slider.dataset.type;

    if (slideType === 'Scrollbar') {
      paginationEl.classList.add('swiper-scrollbar');
      swiperConfig.scrollbar = {
        el: paginationEl,
        draggable: true
      }
    }

    if (slideType === 'Pagination') {
      paginationEl.classList.add('swiper-pagination');
      swiperConfig.pagination = {
        el: paginationEl,
        clickable: true
      }
    }

    if (slideType === 'Pagination progress') {
      paginationEl.classList.add('swiper-scrollbar');
      swiperConfig.pagination = {
        el: paginationEl,
        type: 'progressbar',
      };
      swiperConfig.navigation = {
        nextEl: nextCtrlEl,
        prevEl: prevCtrlEl,
      }
    }

    if (slideType === 'Carousel Slider') {
      slider.classList.add('swiper-carousel');
      paginationEl.classList.add('swiper-pagination');
      let bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
      let initSlider = false;

      const changePagination = (elSwiper, focus = false) => {
        let current = slider.querySelector('[data-swiper-slide-index="' + elSwiper.realIndex + '"]');
        current = current ? current : slider.querySelector('[data-slide-id="0"]');

        current && bullets.forEach(bullet => {
          bullet.classList.toggle('swiper-pagination-bullet-active', bullet.dataset.slideBulletId === current.dataset.slideId)
        });

        !isAutoplay && updateSlidesFocus(elSwiper, focus);
      }

      const changeSlide = (elSwiper, bullet) => {
        let prevSlideId = +paginationEl.querySelector('.swiper-pagination-bullet-active').dataset.slideBulletId;
        let currentId = +bullet.dataset.slideBulletId;
        let slidesTotal = bullets.length - 1;
        // unary plus (+) operator converts its operand to a number.

        let switchDuplicate = Math.abs(currentId - prevSlideId) > 2;
        let duplicateSlide = `.slide-duplicate[data-slide-id="${currentId}"]`;
        let defaultSlide = `[data-slide-id="${currentId}"]:not(.slide-duplicate)`;

        if (currentId === slidesTotal && prevSlideId === 0) {
          elSwiper.slidePrev();
        } else if (prevSlideId === slidesTotal && currentId === 0) {
          elSwiper.slideNext();
        } else {
          const slide = slider.querySelector(
            elSwiper.realIndex < slidesTotal
              ? switchDuplicate ? duplicateSlide : defaultSlide
              : switchDuplicate ? defaultSlide : duplicateSlide
          );
          slide && elSwiper.slideToLoop(slide.dataset.swiperSlideIndex);
        }
      };

      const updateSlidesFocus = (elSwiper, focus) => {
        let slides = slider.querySelectorAll('.swiper-slide');
        let current = slider.querySelector('[data-swiper-slide-index="' + elSwiper.realIndex + '"]');
        current = current ? current : slider.querySelector('[data-slide-id="0"]');

        slides && slides.forEach(slide => {
          let item = slide.querySelector('.content_slider__item');

          item && item.setAttribute('tabindex', slide.classList.contains('swiper-slide-visible') ? '0' : '-1');
        });

        if (focus && elSwiper.realIndex !== 0 && elSwiper.previousIndex !== 0) {
          current.querySelector('.content_slider__item').focus();
        }
      }

      swiperConfig = {
        modules: [EffectCarousel], // pass EffectCarousel module to modules
        effect: 'carousel', // specify "carousel" effect
        // carousel effect parameters
        carouselEffect: {
          opacityStep: 0.33, // opacity change per side slide
          scaleStep: 0.15, // scale change per side slide
          sideSlides: 2, // amount of side slides visible, can be 1, 2 or 3
        },
        grabCursor: true,
        loop: true,
        loopAdditionalSlides: 1,
        slidesPerView: 1,
        slidesPerGroup: 1,
        breakpoints: {
          900: {
            slidesPerView: 2
          },
        },
        keyboard: {
          enabled: true
        },
        navigation: {
          nextEl: prevCtrlEl,
          prevEl: nextCtrlEl,
        },
        slideToClickedSlide: true,
        autoplay: {
          delay: delay,
          enabled: isAutoplay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        on: {
          init: e => bullets && bullets.forEach(bullet => bullet.addEventListener('click', () => {
            changeSlide(e, bullet);
          })),
          resize: e => (bullets && initSlider) && changePagination(e, true),
          slideChange: e => (bullets && initSlider) && changePagination(e, true),
          afterInit: e => {
            initSlider = true;

            changePagination(e);
          }
        }
      };
    }

    if (slideType === 'Related content') {
      const BREAKPOINTS = {
        MOBILE: 375,
        TABLET: 600,
        LAPTOP: 900,
        DESKTOP: 1200
      };

      const SLIDES_PER_BREAKPOINT = {
        [BREAKPOINTS.MOBILE]: 1,
        [BREAKPOINTS.TABLET]: 2,
        [BREAKPOINTS.LAPTOP]: 3,
        [BREAKPOINTS.DESKTOP]: 4
      };

      const createBreakpointConfig = (slidesCount, breakpoint) => ({
        loop: slidesCount > SLIDES_PER_BREAKPOINT[breakpoint] + 1,
        slidesPerView: slidesCount > SLIDES_PER_BREAKPOINT[breakpoint]
          ? SLIDES_PER_BREAKPOINT[breakpoint] + 0.25
          : slidesCount,
        spaceBetween: breakpoint === BREAKPOINTS.DESKTOP ? 24 :
          breakpoint === BREAKPOINTS.MOBILE ? 12 : 16,
      });

      const updateSliderAlignment = (swiper, slidesCount) => {
        const currentBreakpoint = parseInt(Object.keys(swiper.params.breakpoints)
          .filter(bp => window.innerWidth >= bp)
          .sort((a, b) => b - a)[0]) || 0;

        swiper.slidesEl.classList.toggle(
          "justify--center",
          slidesCount <= SLIDES_PER_BREAKPOINT[currentBreakpoint]
        );
      };

      const slidesCount = slider.querySelectorAll('.swiper-slide').length;

      swiperConfig = {
        loop: slidesCount > 1,
        loopAdditionalSlides: 1,
        slidesPerGroup: 1,
        slidesPerView: slidesCount > 1 ? 1.25 : slidesCount,
        spaceBetween: 12,
        centeredSlides: false,
        grabCursor: true,
        setWrapperSize: true,
        keyboard: { enabled: true },
        pauseOnMouseEnter: true,
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev')
        },
        watchOverflow: true,
        breakpoints: Object.fromEntries(
          Object.values(BREAKPOINTS).map(bp => [
            bp,
            createBreakpointConfig(slidesCount, bp)
          ])
        ),
        on: {
          beforeInit: (swiper) => updateSliderAlignment(swiper, slidesCount),
          resize: (swiper) => updateSliderAlignment(swiper, slidesCount)
        },
        slideToClickedSlide: true
      };
    }

    new Swiper(slider, swiperConfig);
  }
})();
